import React from 'react';
import HmAjax from '../../util/HmAjax';
import LoggedInPage from '../../views/core/LoggedInPage';
import $ from 'jquery';

class TimerComp extends LoggedInPage {
  constructor(props) {
    super(props);
    this.state = { time: {}, seconds:3600,timerStarted:false};
    this.timer = 0;

    this.countDown = this.countDown.bind(this);

    this.getTimerStatus = this.getTimerStatus.bind(this);
    this.storeTimerStatus =  this.storeTimerStatus.bind(this);
    this.autoSubmit = this.autoSubmit.bind(this);
    this.storetimerinterval = 0;
    this.timercnt = 0;

    this.startTimer = this.startTimer.bind(this);
    this.stopTimer = this.stopTimer.bind(this);
    this.resumeTimer = this.resumeTimer.bind(this);
    this.pauseTimer = this.pauseTimer.bind(this);

    this.timerActive = false;
  }

  secondsToTime(secs){
    let hours = Math.floor(secs / (60 * 60));

    let divisor_for_minutes = secs % (60 * 60);
    let minutes = Math.floor(divisor_for_minutes / 60);

    let divisor_for_seconds = divisor_for_minutes % 60;
    let seconds = Math.ceil(divisor_for_seconds);

    hours = ("00" + hours).substr(-2);            
    minutes = ("00" + minutes).substr(-2);            
    seconds = ("00" + seconds).substr(-2);

    let obj = {
      "hours": (hours),
      "minutes": (minutes),
      "seconds": (seconds)
    }; 

    return obj;
  }

  componentDidMount() {
    var me=this;
   /* if(this.props.onShow){
      this.getTimerStatus();
    }*/
  }

  componentWillUnmount(){
    if(this.props.onShow){
      this.stopTimer();
    }
  }

  getTimerStatus(){
    //let timeLeftSec = me.secondsToTime(me.state.seconds);
    this.setState({ seconds: this.props.starttime});
    this.startTimer();
  }

  autoSubmit(){
    //Enter all the autosubmit pertaining to timer here

    //Reference function to Submission via GetTest.js
    if(typeof  this.props.autoSubmit === "function")  {
      this.props.autoSubmit();
    }
  }

  storeTimerStatus(){
    var me = this;
    let timerVal = (me.props.elapsedTime + me.timercnt);
    var postParams={			
     "testId":this.props.testDetails.id,
     "time":window.btoa(timerVal),
     "revisionTestId":this.props.testDetails.revisionTestId,
     "topicSubtopicMapId":this.props.testDetails.topicSubTopicMapId
   }


   var callBackSuccess = function(response){
    me.props.callbackParent(timerVal)
    //console.log("Timer is Saved");
  }

  var callBackFailure = function(error){
   console.log("Error in store Timer");
 }

 new HmAjax(this.getUrlFor("STORE_TIMER"),postParams).put(callBackSuccess,callBackFailure);


}

startTimer() {
  if(!this.state.timerStarted){
    this.timerActive = true;
    this.stopTimer();
    this.setState({timerStarted:true});
    if (this.timer == 0 && this.state.seconds > 0) {
      this.timer = setInterval(this.countDown, 1000);
    }
  }else{
    console.warn("Timer already started do not restart");
  }
} 

stopTimer(){
  try{
    clearInterval(this.timer);
  }catch(e){}
  this.setState({timerStarted:false});
}

resumeTimer(){
  if(!this.state.timerStarted){
    this.getTimerStatus();
  }

  this.timerActive = true;
}

pauseTimer(){
  this.timerActive = false;
}

countDown() {
  if(this.timerActive){

    // Remove one second, set state so a re-render happens.
    let seconds = this.state.seconds - 1;
    this.timercnt++;
    this.storetimerinterval++;
    this.setState({
      time: this.secondsToTime(seconds),
      seconds: seconds,
    });
    if(this.storetimerinterval==5){
      this.storeTimerStatus()
      this.storetimerinterval = 0;
    }
    if((this.props.starttime-this.timercnt)<=15) {
      if(! $(".countdown-timer").hasClass("blink")){
        $(".countdown-timer").addClass("blink")
      }
    }
    if((this.props.starttime-this.timercnt)==0) {
      if($(".countdown-timer").hasClass("blink")){
        $(".countdown-timer").removeClass("blink")
      }
      this.autoSubmit();
    }

    // Check if we're at zero.
    if (seconds == 0){ 
      this.stopTimer();
    }
  }
}
renderTimer() {
  var me=this;
  if(me.state.timerStarted && me.state.time.seconds!=undefined) {
    return(
      <span>Time left : &nbsp;
      {me.state.time.hours} : {me.state.time.minutes} : {me.state.time.seconds} </span> 
      )
    }
    else {
      return(
      <span></span>
      )
    }
  }

  render() {
    return(
    <div className="countdown-timer">
    {this.renderTimer()}
    </div>
    );
  }
}
export default TimerComp;



// WEBPACK FOOTER //
// ./src/components/common/TimerComp.js